export enum FONT_TYPES {
  CUSTOM = 'CUSTOM',
  GOOGLE = 'GOOGLE',
}

export type Font = {
  font_type: FONT_TYPES;
  google_font_family: string;
  is_unverified_font_selected: boolean;
} & Partial<CustomFont>;

export interface CustomFont {
  custom_font_name: string;
  custom_font_weight_400: CustomFontWeight;
  custom_font_weight_400_ttf: CustomFontFile;
  custom_font_weight_400_woff: CustomFontFile;
  custom_font_weight_700: CustomFontWeight;
  custom_font_weight_700_ttf: CustomFontFile;
  custom_font_weight_700_woff: CustomFontFile;
}

interface CustomFontWeight {
  id: number;
  name: string;
  font_id: number;
  created_at: string;
  updated_at: string;
}

interface CustomFontFile {
  id: number;
  default_url: string;
  file_url: string;
  file_name: string;
  name: string;
  mime_type: string;
  size: number;
  virus_scan_status: string;
}
